import { getEnv } from '@luna/env';
import { getCurrentLanguage } from '@luna/i18n';
import type { RetailEnvironmentConfig } from '@retail/core-config';
import { selectMyProfileData } from '@shared/profile';

function getPathFromUrl(): string {
    return encodeURIComponent(window.location.hash.substring(1));
}

function getBaseLogoutUrl(): string {
    const { logoutUrl, country } = getEnv<RetailEnvironmentConfig>();

    if (logoutUrl && logoutUrl.default) {
        return logoutUrl.default;
    }

    if (logoutUrl && typeof logoutUrl === 'string') {
        return logoutUrl;
    }

    return `loggedout.html?logout=[[SCENARIO]]&institute=[[INSTITUTE]]&lang=[[CURRENT_GEORGE_LANGUAGE]]&country=${country}&state=${getPathFromUrl()}`;
}

const MOBILE_THRESHOLD = 480;

function isClientMobile(): boolean {
    if (!getEnv<RetailEnvironmentConfig>().mobileClientId) {
        return false;
    }
    if (!window || !window.screen || !window.screen.width) {
        return false;
    }
    return window.screen.width <= MOBILE_THRESHOLD;
}

function getLogoutUrlClientId(): string {
    const config = getEnv<RetailEnvironmentConfig>();

    if (isClientMobile()) {
        return config.mobileClientId;
    }

    return config.clientId;
}

function getLogoutUrlInstitute(): string {
    const instituteId = selectMyProfileData()?.instituteId;

    if (instituteId) {
        return String(instituteId);
    }

    return '';
}

function replaceParameters(_logoutUrl: string, logoutType?: string): string {
    let logoutUrl = _logoutUrl.replace(/\[\[CLIENTID]]/g, getLogoutUrlClientId());
    logoutUrl = logoutUrl.replace(/\[\[SCENARIO]]/g, logoutType || '');
    logoutUrl = logoutUrl.replace(/\[\[INSTITUTE]]/g, getLogoutUrlInstitute());
    logoutUrl = logoutUrl.replace(/\[\[CURRENT_GEORGE_LANGUAGE]]/g, getCurrentLanguage());
    logoutUrl = logoutUrl.replace(/\[\[STATE]]/g, getPathFromUrl());
    logoutUrl = logoutUrl.replace(/\[\[CURRENT_SECTION]]/g, getPathFromUrl());
    return logoutUrl;
}

export function getLogoutUrl(logoutType?: string, customLogoutUrl?: string): string {
    if (customLogoutUrl) {
        return replaceParameters(customLogoutUrl, logoutType);
    }
    const baseLogoutUrl = getBaseLogoutUrl();
    return replaceParameters(baseLogoutUrl, logoutType);
}
